export const SUBTITLE_ARRAY = [
  'Ideal4Finance has received your payment and the job is ready to start. ',
  'Your money is being held securely with Stripe and will only be released to $partner once the job is finished. ',
  'We have let $partner know that you have secured this job and the work is ready to go!',
];

export const SUBTITLE_ARRAY_DELIVERY = [
  'Ideal4Finance has received your payment and your order is ready to be accepted. ',
  'Your money is being held securely with Stripe and will only be released to $partner once your goods have been delivered. ',
  'We have let $partner know that you have secured this order and they can deliver your goods!',
];

export const LINE_2_STANDARD =
  'Upon completion of the job, you will be asked to sign a satisfaction note, confirming the job has been completed and you are happy with the work undertaken.';

export const LINE_2_SUPPLY =
  'Upon delivery of your goods, you will be asked to sign a satisfaction note, confirming the delivery and that you are happy with the delivered goods.';
